import { useState } from 'react'
import { api } from '../api/client.ts'

/**
 * Создание опроса.
 *
 * Два варианта — минимум: опрос из одного пункта это не опрос.
 * Пустые строки в конце просто отбрасываем, а не ругаемся на них:
 * человек добавил поле «про запас» и не заполнил — обычное дело.
 */
export function PollDialog({ chatId, onClose }: { chatId: string; onClose: () => void }) {
  const [question, setQuestion] = useState('')
  const [options, setOptions] = useState(['', ''])
  const [multiple, setMultiple] = useState(false)
  const [anonymous, setAnonymous] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const setOption = (index: number, value: string) =>
    setOptions((current) => current.map((o, i) => (i === index ? value : o)))

  const filled = options.map((o) => o.trim()).filter(Boolean)
  const canSend = question.trim().length > 0 && filled.length >= 2

  const create = async () => {
    setBusy(true)
    setError(null)
    try {
      await api(`/api/chats/${chatId}/polls`, {
        method: 'POST',
        body: { question: question.trim(), options: filled, multiple, anonymous },
      })
      onClose()
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не получилось создать')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="sheet" onClick={onClose}>
      <div className="sheet-body" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-head">
          <h2>Опрос</h2>
          <button className="icon-btn" onClick={onClose} aria-label="Закрыть">
            ✕
          </button>
        </div>

        <label className="field">
          <span className="field-label">Вопрос</span>
          <input
            className="input"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Кто едет в субботу?"
            maxLength={300}
            autoFocus
          />
        </label>

        <span className="field-label">Варианты</span>
        {options.map((option, index) => (
          <div key={index} className="poll-input-row">
            <input
              className="input"
              value={option}
              onChange={(e) => setOption(index, e.target.value)}
              placeholder={`Вариант ${index + 1}`}
              maxLength={100}
            />
            {options.length > 2 && (
              <button
                className="icon-btn"
                onClick={() => setOptions((c) => c.filter((_, i) => i !== index))}
                aria-label="Убрать вариант"
              >
                ✕
              </button>
            )}
          </div>
        ))}

        {options.length < 10 && (
          <button className="link-btn" onClick={() => setOptions((c) => [...c, ''])}>
            + Добавить вариант
          </button>
        )}

        <label className="switch-row">
          <input type="checkbox" checked={multiple} onChange={(e) => setMultiple(e.target.checked)} />
          <span>Можно выбрать несколько</span>
        </label>

        <label className="switch-row">
          <input
            type="checkbox"
            checked={anonymous}
            onChange={(e) => setAnonymous(e.target.checked)}
          />
          <span>
            Тайное голосование
            <span className="switch-hint">Числа видны всем, имена — никому</span>
          </span>
        </label>

        {error && <div className="sheet-error">{error}</div>}

        <button className="btn-primary" onClick={() => void create()} disabled={!canSend || busy}>
          {busy ? '…' : 'Отправить опрос'}
        </button>
      </div>
    </div>
  )
}
